// extracted by mini-css-extract-plugin
module.exports = {"menuItems":"DropdownMenu_menuItems__0OU65"};